<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-btn text icon color="green">
              <v-icon @click.native="doExit">mdi-keyboard-backspace</v-icon>
            </v-btn>
            <v-icon>mdi-magnify</v-icon>
            <v-toolbar-title>{{ labels.sanctionDet }}</v-toolbar-title>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <div style="padding-left: 15px">
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.dataId }}</v-subheader>
                      <span class="queryValue">{{ this.form.dataId }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.genDate }}</v-subheader>
                      <span class="queryValue">{{ this.form.genDate }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.listDate }}</v-subheader>
                      <span class="queryValue">{{ this.form.listDate }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.unListType }}</v-subheader>
                      <span class="queryValue">{{ this.form.unListType }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.name1 }}</v-subheader>
                      <span class="queryValue">{{ this.form.name1 }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.name2 }}</v-subheader>
                      <span class="queryValue">{{ this.form.name2 }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.name3 }}</v-subheader>
                      <span class="queryValue">{{ this.form.name3 }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.name4 }}</v-subheader>
                      <span class="queryValue">{{ this.form.name4 }}</span>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg6>
                      <v-subheader class="queryLabel">{{ labels.fullName }}</v-subheader>
                      <span class="queryValue">{{ this.form.fullName }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.quality }}</v-subheader>
                      <span class="queryValue">{{ this.form.quality }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.deListDate }}</v-subheader>
                      <span class="queryValue">{{ this.form.deListDate }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.refNo }}</v-subheader>
                      <span class="queryValue">{{ this.form.refNo }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.docNo }}</v-subheader>
                      <span class="queryValue">{{ this.form.docNo }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.dob }}</v-subheader>
                      <span class="queryValue">{{ this.form.dob }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.gender }}</v-subheader>
                      <span class="queryValue">{{ this.form.gender }}</span>
                    </v-flex>
                    <v-flex xs12>
                      <v-subheader class="queryLabel">{{ labels.comment }}</v-subheader>
                      <v-textarea v-model="this.form.comment" :rows="5" readonly></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-data-table :headers="headers" :items="items" class="elevation-1" :loading="loading">
                        <template v-slot:item="row"
                          ><tr>
                            <td>{{ row.item.aliasName }}</td>
                            <td>{{ row.item.aliasQuality }}</td>
                          </tr></template
                        >
                      </v-data-table>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.createdByFirstName }}</v-subheader>
                      <span class="queryValue">{{ sanction.createdByFirstName }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                      <span class="queryValue">{{ sanction.createdDate }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.modifiedByFirstName }}</v-subheader>
                      <span class="queryValue">{{ sanction.modifiedByFirstName }}</span>
                    </v-flex>
                    <v-flex xs12 sm3 md3 lg3>
                      <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                      <span class="queryValue">{{ sanction.modifiedDate }}</span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      labels: {
        sanctionDet: 'Sanction Details',
        dataId: 'Data Id',
        genDate: 'Generated Date',
        name1: 'First Name',
        name2: 'Second Name',
        name3: 'Third Name',
        name4: 'Fourth Name',
        fullName: 'Full Name',
        quality: 'Quality',
        unListType: 'List Type',
        refNo: 'Reference',
        listDate: 'List Date',
        deListDate: 'Delisted Date',
        comment: 'Comment',
        gender: 'Gender',
        dob: 'Date of Birth',
        docNo: 'Document No.',
        createdByFirstName: 'Created By',
        createdDate: 'Created Date',
        modifiedByFirstName: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        sanctionDet: null,
        dataId: null,
        genDate: null,
        name1: null,
        name2: null,
        name3: null,
        name4: null,
        fullName: null,
        quality: null,
        unListType: null,
        refNo: null,
        listDate: null,
        deListDate: null,
        comment: null,
        gender: null,
        dob: null,
        docNo: null,
        createdByFirstName: null,
        createdDate: null,
        modifiedByFirstName: null,
        modifiedDate: null
      },
      headers: [
        { text: 'Aliases', value: 'aliasName' },
        { text: 'Quality', value: 'aliasQuality' }
      ],
      items: []
    }
  },
  methods: {
    async doInit() {
      const apiURI = this.$store.state.underwriting.dataTransferSettings.menu.sanctionAliasList
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            dataId: this.sanction.dataId
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.form.dataId = data.sanction.dataId
            this.form.genDate = formatDisplayDate(data.sanction.genDate)
            this.form.name1 = data.sanction.name1
            this.form.name2 = data.sanction.name2
            this.form.name3 = data.sanction.name3
            this.form.name4 = data.sanction.name4
            this.form.fullName = data.sanction.fullName
            this.form.unListType = data.sanction.unListType
            this.form.refNo = data.sanction.refNo
            this.form.listDate = formatDisplayDate(data.sanction.listDate)
            this.form.deListDate = formatDisplayDate(data.sanction.deListDate)
            this.form.gender = data.sanction.gender
            this.form.comment = data.sanction.comment
            this.form.dob = formatDisplayDate(data.sanction.dob)
            this.form.docNo = data.sanction.docNo
            this.form.quality = data.sanction.quality
            this.form.createdByFirstName = data.sanction.createdByFirstName
            this.form.createdDate = formatDisplayDate(data.sanction.createdDate)
            this.form.modifiedByFirstName = data.sanction.modifiedByFirstName
            this.form.modifiedDate = formatDisplayDate(data.sanction.modifiedDate)
            if (data && Array.isArray(data.alias)) {
              data.alias.map((aliasItem) => {
                const convertList = {
                  dataId: aliasItem.dataId,
                  aliasName: aliasItem.aliasName,
                  aliasQuality: aliasItem.aliasQuality,
                  dateGen: formatDisplayDate(aliasItem.dateGen)
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.$toast.error('Invalid Record')
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doExit() {
      window.history.back()
    }
  },
  props: ['sanction'],
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin]
}
</script>

<style>
</style>
